import {
  DEFAULT_ADVISOR_FEE,
  DEFAULT_WITHDRAWAL_START_YEAR,
} from "../../../../../utils/constant";

export const CHART_VIEW_OBJECTIVE_GROWTH = ["projection", "contributions"];

export const CHART_VIEW_OBJECTIVE_INCOME = [
  "projection",
  "income",
  "contributions",
];

export const DEFAULT_SIMULATIONS_AMOUNT = 100;

export const DEFAULT_WITHDRAWAL_LEVEL_DOLLAR = 100000;

export const DEFAULT_WITHDRAWAL_LEVEL_PERCENT = 4;

export const LEAD_MAX_RATE_VALUE = 5;

export const PROPOSAL_DEFAULT_DATA_LEVEL = {
  advisorFee: DEFAULT_ADVISOR_FEE,
  birthYear: 1972,
  contributions: 12000,
  investmentAmount: 500000,
  investmentDuration: 20,
  investmentObjective: "growth",
  organization: "level2",
  riskTolerance: "Moderate",
  withdrawalLevel: "4%",
  yearToStartWithdrawals: DEFAULT_WITHDRAWAL_START_YEAR,
};

export const PROPOSAL_GOAL_TYPE_LEVEL = [
  {
    value: "growth",
    label: "Drive Growth",
  },
  {
    value: "income",
    label: "Drive Income",
  },
  {
    value: "growth_income",
    label: "Drive Growth & Income",
  },
];

export const PROPOSAL_SAMPLE_URL_LEVEL =
  "https://ontrajectory.s3.amazonaws.com/level/level_proposal_sample.pdf";

export const RISK_TYPES_LEVEL = [
  { value: "aggressive", label: "Aggressive" },
  { value: "growth", label: "Growth" },
  { value: "moderate", label: "Moderate" },
  { value: "conservative", label: "Conservative" },
  { value: "preservation", label: "Preservation" },
];
